import angular from 'angular';
import sectionsLibraryService from './../../../SectionsLibraryService';
import toolbarService from './../../../../Toolbar/ToolbarService';

import template from './social.mjml';
import './Social.scss';
import MjmlTemplateExtractor from './../../../Mjml/MjmlTemplateExtractor';
import FacebookUrl from "../../../../ConfigParameters/ConfigParameters/FacebookUrl";
import GooglePlusUrl from "../../../../ConfigParameters/ConfigParameters/GooglePlusUrl";
import BackgroundColor from "../../../../ConfigParameters/ConfigParameters/BackgroundColor";
import Align from "../../../../ConfigParameters/ConfigParameters/Align";
import LinkedInUrl from "../../../../ConfigParameters/ConfigParameters/LinkedInUrl";
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import InstagramUrl from "../../../../ConfigParameters/ConfigParameters/InstagramUrl";
import TwitterUrl from "../../../../ConfigParameters/ConfigParameters/TwitterUrl";
import PinterestUrl from "../../../../ConfigParameters/ConfigParameters/PinterestUrl";


const creatorMailSectionSocial = {
    bindings: {
        elementModel: '=',
    },
    template: MjmlTemplateExtractor(template),
    controller: function (ToolbarService, gettextCatalog, $element) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema('social');

        $element.find('a').on('click', function (e) {
            e.preventDefault();
        });

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
            this.placeholderText = gettextCatalog.getString('Click to set module options', null, "Creator section module placeholder");
        }

    }
};

export default angular.module('cms.creator.mail.section-social', [sectionsLibraryService, toolbarService])
    .run(function (SectionsLibraryService, ToolbarService, gettext) {

        SectionsLibraryService.registerSection({
            icon: 'group',
            type: 'social',
            label: gettext('Social'),
            group: 'mail',
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                }
            }
        });
        //facebook google instagram pinterest linkedin twitter
        ToolbarService.registerSectionSchema('social', {
            ...(new FacebookUrl()),
            ...(new GooglePlusUrl()),
            ...(new LinkedInUrl()),
            ...(new InstagramUrl()),
            ...(new TwitterUrl()),
            ...(new PinterestUrl()),
            ...(new Align()),
            ...(new BackgroundColor()),
            ...(new Paddings({value: 15, unit: 'px'},{value: 30, unit: 'px'},['px']))
        });

    })
    .component('cmsCreatorMailSectionSocial', creatorMailSectionSocial).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Mail/Social/Social.js